// extracted by mini-css-extract-plugin
module.exports = {"recentSpendingTierLegend":"index__recentSpendingTierLegend__yQa7a","header":"index__header__2y-L9","title":"index__title__3udHV","capitalize":"index__capitalize__2NNkr"};